import * as ACTION from 'actions';
import _ from 'lodash';

const initialState = {
    serialCode: null,
    serialCodeData: null
};

export function serialCode(state = initialState, action) {
    if (action == null) return state;
    switch (action.type) {
        case ACTION.FETCH_SERIAL_CODE:
            return {
                ...state,
                serialCode: action.serialCode,
            }
        case ACTION.UPDATE_SERIAL_CODE:
            return {
                ...state,
                serialCode: action.serialCode,
            }
        default:
            return state
    }
}

export function serialCodes(state=[], action) {
    if(action == null) return  state;
    let _serialCodes = Object.assign([], state);
    let index = -1;
    switch (action.type) {
        case ACTION.FETCH_SERIAL_CODE_LIST:
            return _.sortBy(action.serialCodes, 'createdAt');
        case ACTION.UPDATE_SERIAL_CODE:
            index = state.findIndex(data => data.id === action.serialCode.id);
            _serialCodes[index] = action.serialCode;
            return _serialCodes;
        case ACTION.ADD_SERIAL_CODE:
            return [...state,action.serialCode];
        case ACTION.DELETE_SERIAL_CODE:
            index = state.findIndex(data => data.id === action.serialCode.id);
            _serialCodes.splice(index, 1);
            return _serialCodes;
        default:
            return state
    }
}
